/**
 * Created by rhinov8e on 09/10/2015.
 */

import { EntityNode } from "../plan/EntityNodes/EntityNode";
import { PlanManager } from "../../../cocosPlan";
import { Grid } from "../plan/grid";
import { Events, eventsManager, SavaneConstants } from "@rhinov/savane-js";

declare var cc: any;


export class Utils {

    static TOUCH_SNAP_TIME: number = 150;// Time in milliseconds above wich the click is considered as a simple click (used for deselection of tools)
    static DIMENSION_DIST: number = 12;// Distance from wall of quotes
    static baseZoom: number = 0;
    static angleTolerance: number = 0.025;
    static timeDoubleClick: number = 300; //ms

    constructor() {
        
    }

    static get magnetDistance(): number {
        var zoomRatio = this.baseZoom / PlanManager.getInstance().getZoomScale();
        return SavaneConstants.MagnetDistance * zoomRatio;
    }

    static get roomMagnetDistance(): number {
        var zoomRatio = this.baseZoom / PlanManager.getInstance().getZoomScale();
        return SavaneConstants.RoomMagnetDistance * zoomRatio;
    }

    static get angleMagnet(): number {
        var zoomRatio = this.baseZoom / PlanManager.getInstance().getZoomScale();
        return this.angleTolerance * zoomRatio;
    }

    static get startDraggingConstant(): number {
        return 100;
    }

    static getChildByTagRecursivly(rootNode: EntityNode, tag: number): EntityNode | null {
        for (var i = 0; i < rootNode.childrenCount; i++) {
            if (rootNode.children[i].getTag() === tag) {
                return rootNode.children[i];
            } else {
                var nodeValue = Utils.getChildByTagRecursivly(rootNode.children[i], tag);
                if (nodeValue !== null)
                    return nodeValue;
            }
        }
        return null;
    };

    static getChildByTag(rootNode: EntityNode, tag: number): EntityNode | null {
        for (var i = 0; i < rootNode.childrenCount; i++) {
            if (rootNode.children[i].getTag() === tag) {
                return rootNode.children[i];
            }
        }
        return null;
    };
    static getChildByName(rootNode: EntityNode, name: number): EntityNode | null {
        for (var i = 0; i < rootNode.childrenCount; i++) {

            if (rootNode.children[i].getName() === name) {
                return rootNode.children[i];
            }
        }
        return null;
    };

    static getChildByNameRecursivly(rootNode: Grid, name: number | string): EntityNode | null {
        var i;
        for (i = 0; i < rootNode.childrenCount; i++) {
            if (rootNode.children[i].getName() === name) {
                return rootNode.children[i];
            }
        }
        for (i = 0; i < rootNode.childrenCount; i++) {
            var nodeValue = Utils.getChildByNameRecursivly(rootNode.children[i], name);
            if (nodeValue !== null)
                return nodeValue;
        }
        return null;
    };

    static getClosestNumberInArray(toFind: number, array: number[]): number {
        var closest = 0;
        var diff = Math.abs(toFind);
        for (var i = 0; i < array.length; ++i) {
            if (Math.abs(toFind - array[i]) < diff) {
                diff = Math.abs(toFind - array[i]);
                closest = array[i];
            }
        }
        return closest;
    };

    static sign(x: number): number {
        if (x === 0)
            return x;

        return x > 0 ? 1 : -1;
    };

    /**
     * save the value in a local file
     * @param filename
     * @param value
     */
    static isLocalAvailable() {
        var mod = 'modernizr';
        try {
            localStorage.setItem(mod, mod);
            localStorage.removeItem(mod);
            return true;
        } catch (e) {
            return false;
        }
    };

    static localStorageAvailable = this.isLocalAvailable();

    static saveLocal(filename: string, value: string) {
        if (!Utils.localStorageAvailable) {
            return null;
        }
        try {
        cc.sys.localStorage.setItem(filename, value);
        }
        catch(e) {
            eventsManager.instance.dispatch(Events.DISPLAY_ALERT, { message: 'La sauvegarde locale du projet a provoqué une erreur. Votre projet est probablement trop volumineux (max 5MB). Vérifiez le plan papier si vous en avez un. Sauvegardez le dans un format plus compact (JPG par exemple) ou supprimez le.' });
        }
    };

    /**
     * save the value in a local file
     * @param filename
     */
    static deleteLocal(filename: string) {
        if (!Utils.localStorageAvailable) {
            return null;
        }
        cc.sys.localStorage.removeItem(filename);
    };

    /**
     * get the value of a local file
     * @param filename
     */
    static getLocal(filename: string) {
        if (!Utils.localStorageAvailable) {
            return null;
        }
        return cc.sys.localStorage.getItem(filename);
    };
}


// /**
//  * Created by DjO on 21/09/15.
//  */

// /**
//  * Define a class "subclass" with inheritance from "superclass" and add "methods" to it
//  *
//  * @param {Object} subClass
//  * @param {Object} superClass
//  * @param {Object} methods
//  */
// Utils.defineClass = function (subClass, superClass, methods) {
//     subClass.prototype = Utils.inherit(superClass);
//     subClass.extend(subClass, methods);
// };

// /**
//  * Extends a class "constructor" with "methods"
//  *
//  * @param {Object} constructor
//  * @param {Object} methods
//  */
// Function.prototype.extend = function (constructor, methods) {
//     return Utils.createSubclass(this, constructor, methods);
// };

// /**
//  * Create an Object from a prototype of "superClass"
//  *
//  * @param {Object} superClass
//  * @returns {Object} superClass
//  */
// Utils.inherit = function (superClass) {
//     if (superClass === null) {
//         throw TypeError();
//     }
//     return Object.create(superClass.prototype);
// };

// /**
//  * Create a subclass
//  *
//  * @param {Object} superClass
//  * @param {Object} constructor
//  * @param {Object} methods
//  * @returns {Object}
//  */
// Utils.createSubclass = function (superClass, constructor, methods) {
//     constructor.prototype = Utils.inherit(superClass);
//     constructor.prototype.constructor = constructor;

//     if (methods) {
//         Utils.arrayCopy(constructor.prototype, methods);
//     }

//     return constructor;
// };

// Utils.arrayCopyAvoidOverride = function (destination, source) {
//     for (var element in source) {
//         if (destination[element] == null) {
//             destination[element] = source[element];
//         }

//     }
// };

// Utils.arrayCopy = function (destination, source) {
//     for (var element in source) {
//         destination[element] = source[element];
//     }
// };
// //OLD
// //TODO Remove this part
// Utils.classInheritance = function (superClass, derivedClass) {
//     var protoSuperClass = superClass.prototype;
//     var protoDerivedClass = derivedClass.prototype;
//     Utils.arrayCopyAvoidOverride(protoDerivedClass, protoSuperClass);
// };


// /*Utils.arrayCopyAvoidOverride = function(source, destination) {
//     for (var element in source) {
//         if (destination[element] == null) {
//             destination[element] = source[element];
//         }

//     }
// };

// Utils.arrayCopy = function(source, destination) {
//     for (var element in source) {
//         destination[element] = source[element];
//     }
// };*/


